// extracted by mini-css-extract-plugin
export default {"garanties":"swJCK","container":"SBY25","item":"m4DVX","imageWrapper":"qYSFK","guaranteeText":"ty4UO","icon":"ztg8x","text":"A5cw9"};